import React, { Component } from 'react';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import {ToastContainer} from 'react-toastify'

// Material helpers
import { MuiThemeProvider } from '@material-ui/core/styles';

// Theme
import theme from './theme';
import './assets/scss/index.scss';
import 'react-perfect-scrollbar/dist/css/styles.css';

// Routes
import Routes from './Routes';
import 'react-toastify/dist/ReactToastify.css';

import { QueryClientProvider, QueryClient } from '@tanstack/react-query'

// Observability
import {initRum, setRumUser} from './observability/rum';
import {initLogs} from './observability/logger';

initRum();
initLogs();
if (sessionStorage.getItem('user')) {
  setRumUser({
    id: sessionStorage.getItem('user'),
    name: sessionStorage.getItem('user_name'),
    email: sessionStorage.getItem('email'),
    adminId: sessionStorage.getItem('admin_id'),
  });
}

// Browser history
const browserHistory = createBrowserHistory();

export const queryClient = new QueryClient()

export default class App extends Component {
  render() {
    return (
      <QueryClientProvider client={queryClient}>
        <MuiThemeProvider theme={theme}>
          <Router history={browserHistory}>
            <Routes />
          </Router>
          <ToastContainer />
        </MuiThemeProvider>
      </QueryClientProvider>
    );
  }
}
